import React, {useContext, useState} from 'react';
import {Table, TableBody, TableCell, TableHead, TableRow} from '@bosch/react-frok';
import {ContentWrapper} from './ItemTable.style';
import {ItemTableRow} from './ItemTableRow';
import {t} from 'i18next';
import {ItemProps} from '../ItemProps';
import {AuthContext} from '../../../context/AuthContext';
import {hasEditorialAccess} from '../../../utils/UserUtils';
import {generateIdentifier} from '../../../utils/IdentityUtils';

/**
 * @name ItemTable
 * @description
 * Component to show a download item (folder/file) for the table visualisation.
 */
export const ItemTable = (props: ItemProps) => {
    const {isAuthenticated, roles} = useContext(AuthContext);
    const [isEditorialAccess] = useState<boolean>(hasEditorialAccess(isAuthenticated, roles));

    return (
        <ContentWrapper id={generateIdentifier()}>
            <Table id={generateIdentifier()}>
                <TableHead id={generateIdentifier()}>
                    <TableRow id={generateIdentifier()}>
                        <TableCell id={generateIdentifier()} header secondary></TableCell>
                        <TableCell id={generateIdentifier()} header secondary>
                            {t('ITEM_VISUALISATION_TITLE_HEADLINE')}
                        </TableCell>
                        <TableCell id={generateIdentifier()} header secondary>
                            {t('ITEM_VISUALISATION_FILE_TYPE_HEADLINE')}
                        </TableCell>
                        <TableCell id={generateIdentifier()} header secondary>
                            {t('ITEM_VISUALISATION_UPLOAD_HEADLINE')}
                        </TableCell>
                        <TableCell id={generateIdentifier()} header secondary>
                            {t('ITEM_VISUALISATION_FILE_SIZE_HEADLINE')}
                        </TableCell>
                        {isEditorialAccess ?
                            <TableCell id={generateIdentifier()} header secondary>
                                {t('PUBLIC_ACCESS')}
                            </TableCell>
                            : <div id={generateIdentifier()}></div>
                        }
                        <TableCell id={generateIdentifier()} header secondary></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody id={generateIdentifier()}>
                    {props.items.map(item => (
                        <ItemTableRow key={item.id}
                                      item={item}
                                      language={props.language}
                                      defaultLocale={props.defaultLocale}
                                      showEdit={props.editMode}
                                      isFavoriteToggle={props.favoriteItems.includes(item.id)}
                                      labelData={props.labelData ?? []}
                                      onEditClicked={() => props.onEdit(item)}
                                      onDeleteClicked={() => props.onDelete(item)}
                                      onDownloadClicked={() => props.onDownload(item)}
                                      onDetailsClicked={() => props.onShowDetails(item)}
                                      onFavoriteClicked={() => props.onMarkAsFavorite(item, props.favoriteItems)}
                                      onClick={() => props.onItemSelect(item)}
                                      onPreviewClicked={() => props.onShowPreview(item)}
                                      onCopyUrlClicked={() => props.onCopyUrl(item)}/>
                    ))}
                </TableBody>
            </Table>
        </ContentWrapper>
    );
};
